import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Building2, Users, Plug } from 'lucide-react';

export function SettingsTabs() {
  const { t } = useTranslation();
  const location = useLocation();

  const tabs = [
    {
      name: t('settings.tabs.companyDetails'),
      path: '/settings/company',
      icon: Building2,
    },
    {
      name: t('settings.tabs.teamManagement'),
      path: '/settings/team',
      icon: Users,
    },
    {
      name: 'ממשקים וחיבורים',
      path: '/settings/integrations',
      icon: Plug,
    },
  ];

  return (
    <div className="border-b border-gray-200">
      {/*
        RTL fix:
        – Replace `space-x-8` (LTR-only spacing utility) with `gap-6` so
          the gap is applied correctly in both LTR and RTL layout modes.
        – Replace `-ml-0.5 mr-2` on the icon (LTR-only margin shorthand)
          with `me-2` (margin-inline-end) and `flex-shrink-0` so the icon
          and label never collapse or overlap in RTL.
      */}
      <nav className="-mb-px flex flex-wrap gap-6" aria-label="Settings tabs">
        {tabs.map((tab) => {
          // Match both /settings/... and /app/settings/... (after redirect)
          const isActive =
            location.pathname === tab.path ||
            location.pathname === `/app${tab.path}`;
          const Icon = tab.icon;

          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={`
                group inline-flex items-center py-4 px-1 border-b-2 font-medium text-sm
                transition-colors duration-200 whitespace-nowrap
                ${
                  isActive
                    ? 'border-primary-600 text-primary-700'
                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                }
              `}
              aria-current={isActive ? 'page' : undefined}
            >
              <Icon
                className={`
                  flex-shrink-0 me-2 h-5 w-5
                  ${isActive ? 'text-primary-600' : 'text-gray-400 group-hover:text-gray-500'}
                `}
                aria-hidden="true"
              />
              {tab.name}
            </Link>
          );
        })}
      </nav>
    </div>
  );
}
